import React from 'react'; // eslint-disable-line no-unused-vars
import styles from './BackendSelector.css';
import baseComponent from '../../decorators/baseComponent';
import Header from '../Header';
import BaseReactComponent from '../Util/BaseReactComponent';
import { connect } from 'react-redux';
import Context from '../../Context';
import Backend from './Backend/Backend';
import * as LoginActions from '../../actioncreators/LoginActions';
import { Checkbox } from 'material-ui';
import { getConfig } from '../settings';

@connect(state => ({
  user: state.login.user,
  backends: state.login.user.backends,
  config: getConfig(state)
}))
//@withContext
@baseComponent(styles)
class BackendSelector extends BaseReactComponent {
  constructor(props) {
    super(props);
    this.state = {
      remember: false
    };
  }

  componentWillMount() {
    if (this.props.config) {
      this.context.router.push('/');
    }
  }

  handleClick(backend) {
    console.log('Selecting backend ' + backend.title);

    if (this.state.remember) {
      console.log('setting as default: ' + backend);
      LoginActions.selectDefaultBackend(this.props.user, backend)(this.props.dispatch);
    }
    console.log('setting backend: ' + backend);
    LoginActions.selectBackend(backend)(this.props.dispatch);

    const next = this.props.location.query.nextPathname;
    this.context.router.push(next ? next : '/');
  }

  handleCheck = (ev, checked) => {
    this.setState({
      remember: checked
    });
  };

  render() {
    Context.getInstance().onSetTitle(this.getIntlMessage('backendselectorpage.title'));
    if (!this.props.backends.length) {
      this.context.router.replace('/login');
      return <div />;
    }

    let items = [];
    for (let i = 0; i < this.props.backends.length; i++) {
      items.push(
        <Backend key={i} backend={this.props.backends[i]} onClick={() => this.handleClick(this.props.backends[i])} />
      );
    }

    return (
      <div className="BackendSelectorPage">
        <Header pageName="BackendSelectorPage" showMenu={false} />

        <div className="backend-selection">
          <h1 className="backendselector-title">{this.getIntlMessage('backendselectorpage.title')}</h1>

          <div className="backends">{items}</div>
        </div>

        {typeof localStorage !== 'undefined' ? (
          <div className="checkbox-container">
            <Checkbox
              className="rememberchoice"
              label={this.getIntlMessage('backendselectorpage.rememberchoice')}
              onCheck={this.handleCheck}
            />
          </div>
        ) : (
          undefined
        )}
      </div>
    );
  }
}

const types = BackendSelector.contextTypes;

BackendSelector.contextTypes = {
  ...types,
  router: React.PropTypes.object.isRequired
};

export default BackendSelector;



// WEBPACK FOOTER //
// /src/components/BackendSelector/BackendSelector.js